//Install
import React, { Component } from "react";
//Install
import { ReactComponent as R2704N } from "../../../../Media/Icon/009.svg";

//Element
class Close extends Component {
    //Element
    onClick = (e) => {
        //Element
        e.preventDefault()
        //Element
        let Body = document.getElementsByTagName( "body" )[0]
        //Element
        let Icon = document.getElementById( "Web_AL8709" )
        //Element
        let Close = document.getElementById( "Web_HW24G3" )
        //Element
        let Menu = document.getElementsByClassName( "j11251" )[0]
        //Element
        Icon.classList.toggle( "d-none" )
        //Element
        Close.classList.toggle( "d-none" )
        //Element
        Menu.classList.toggle( "d-none" )
        //Element
        Body.classList.toggle( "overflow-hidden" )
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("button", { id: "Web_HW24G3", name: "Web_HW24G3", className: "S0u16d C96Q4r ZH339f d721Vx pEO064 a527eB m46w74 d-none", type: "button", onClick: this.onClick },
            //Element
            React.createElement(R2704N, {})
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Close;